import React from 'react';
import { useAuth } from '../Login/AuthContext';
import './AiAllowance.css';
export default function AiAllowance() {
  const { user, aiAllowance } = useAuth() || {};
  if (!user || !aiAllowance) return null;
  const { usage, error, loading, refresh } = aiAllowance;
  if (!usage) return <section className="ai-allowance no-print" aria-label="Daily AI allowance">
    <p role="status">{error || (loading ? 'Checking your daily AI allowance…' : 'Daily AI allowance')}</p>
    {error && <button onClick={refresh}>Retry usage check</button>}
    <p>Generation uses a daily AI allowance. Download credits are separate.</p>
  </section>;
  const reached = usage.remaining === 0;
  const exhausted = usage.used >= usage.limit;
  const reset = new Date(usage.resetsAt).toLocaleString(undefined, { weekday: 'short', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' });
  return <section className={`ai-allowance no-print${reached ? ' ai-allowance-reached' : ''}`} aria-label="Daily AI allowance">
    <div className="ai-allowance-heading"><strong>Daily AI allowance</strong><span>{usage.remaining} of {usage.limit} remaining</span></div>
    <progress aria-label="Daily AI allowance remaining" max={usage.limit} value={usage.remaining} />
    <p>Resets {reset} (your local time).</p>
    {usage.pending > 0 && <p>{usage.pending} request{usage.pending === 1 ? '' : 's'} in progress; {usage.pending === 1 ? 'its slot is' : 'their slots are'} temporarily reserved.</p>}
    <p>New AI worksheets and regenerations share this allowance. Failed generations don’t count. No download credits used.</p>
    {reached && <div role="status"><strong>{exhausted ? 'You’ve used today’s AI allowance.' : 'Your remaining allowance is reserved by requests in progress.'}</strong>
      <p>You can still edit, save, format, preview and download your worksheets.</p>
      {exhausted && !usage.paidEligible && <a href="/buycredits">{usage.paidLimit ? `View credit packs for ${usage.paidLimit} AI generations per day` : 'View credit packs for a higher daily allowance'}</a>}
    </div>}
    {error && <p role="status">{error} <button onClick={refresh}>Refresh usage</button></p>}
  </section>;
}
